import {
  curry, compose, map, filter, isEmpty, isNil, objOf, cond, identity, toPairs, T,
} from 'ramda';
import { checkIfValueIncluded } from '../commonHelpers';

const filterAndTransformCondition = curry((filterAcc, acc, data) => compose(
  map(acc),
  filter(filterAcc),
  toPairs,
)(data));

const filterParamKey = (item) => {
  const value = item[1];
  return !isEmpty(value) && !isNil(value);
};

const makeNewFilterValue = curry((merger, name, addNewValue, value) => compose(
  merger,
  objOf(name),
  addNewValue,
)([value]));

const handlerFilter = (condition, errorHandler, successHandler, value) => cond([
  [condition, errorHandler],
  [T, successHandler],
])(value);

const updateFilterAndUrlParams = curry((setFilters, actionUrl, filters, urlParam) => {
  setFilters(filters);
  actionUrl(urlParam);
  return filters;
});

const setFilterForSingleParam = curry((merger, setFilters, onSetUrlParam, name, value) => {
  const updateSprintFilter = makeNewFilterValue(merger, name, identity);
  const filters = handlerFilter(isNil, updateSprintFilter, value);
  updateFilterAndUrlParams(setFilters, onSetUrlParam, filters, ({ [name]: value }));
  return value;
});

export {
  setFilterForSingleParam,
  checkIfValueIncluded,
  filterAndTransformCondition,
  filterParamKey,
  makeNewFilterValue,
  updateFilterAndUrlParams,
  handlerFilter,
};
